// extracted by mini-css-extract-plugin
export default {"container":"table-block_container__2Q9vP"};